export default __webpack_public_path__ + "static/media/m_review_bg.4333699a.png";